export default {
    ADDITIONAL_CONTROL_TYPE: "Дополнительный контроль",
    DEVIATION_REASON: "Причина отклонения",
    CARGO_CONDITION: "Состояние груза",
    AGE_TYPE: "Возраст",
    BUSINESS_OPERATION: "Операция бизнес процесса",
    BUSINESS_PROCESS: "Бизнес процесс",
    CLASS_ACCESS_DOCS: "Разрешительный документ",
    CLASS_ACCESS_DOCS_FROM_PART_NUMBER_POSITION: "Разрешительный документ",
    CLASS_ACCESS_DOCS_TYPE: "Код разрешительного документа",
    CLASS_ACCESS_DOCS_TYPE_COUNT_44: "Наименование, сведения разрешительного документа (графа 44)",
    COLOR: "Цвет",
    COMPANY_CRM: "Запрос",
    COMPANY_CRM_EVENT: "Событие CRM",
    COMPANY_CRM_EVENT_CONNECTION_TYPE: "Вид связи",
    COMPANY_CRM_EVENT_IMPORTANT: "Приоритет",
    COMPANY_CRM_EVENT_TYPE: "Тип события",
    COMPANY_CRM_STATUS: "Статус",
    COMPANY_CRM_TYPE_REQUEST: "Вид запроса",
    COMPANY_DOC_NUMBER_MASK: "Шаблоны номеров",
    COMPANY_GTD_BALANCE: "Баланс",
    CONTRACTS_ADDITION: "Приложения договора",
    CONTRACTS_ADDITION_TYPE: "Тип приложения договора",
    CONTRACTS_FEA: "Контракт ВЭД",
    CONTRACTS_FEA_ADDITION: "Дополнительное соглашение",
    CONTRACTS_MATH_DETAILS: "Детализация расчетов",
    CONTRACTS_PAYMENT_TYPE: "Оплата",
    CONTRACTS_RELATION_TYPE: "Тип взаимоотношений",
    CONTRACTS_STATUS: "Статус",
    COURIER: "Курьер",
    CRM_REQUEST_SOURCE: "Источник запроса",
    CURRENT_USER_TASK: "Задачи",
    DATA_CHANGES_LOG_YUNAS: "Загрузка XML Yunas",
    DEPARTMENT: "Отделы",
    DOCUMENT_MANAGEMENT: "Документооборот",
    DOCUMENT_MANAGEMENT_DOC_TYPE: "Тип документа (документооборот)",
    DOC_OPERATION: "Документальная операция",
    DOC_OPERATION_TYPE: "Тип документальной операции",
    DOC_OPERATION_UNIT_LINK: "Документальная операция",
    EFFEX_EVENTS_UNIT: "События Effex",
    FIN_OPERATION: "Фин.операции",
    ORDER_REQUEST_CURRENCY_TRANSLATION: "Валютные переводы",
    FIN_OPERATION_SALE: "Фин.операции продажа",
    FIN_OPERATION_SALE_EASTEX: "Фин.операции продажа",
    FIN_OPERATION_BUY: "Фин.операции покупка",
    FIN_OPERATION_BUY_EASTEX: "Фин.операции покупка",
    FIN_OPERATION_BY_UNIT: "Финансовая схема",
    FIN_OPERATION_DETAIL_TYPE: "Тип детализации",
    FIN_OPERATION_GROUP_UNIT: "Грузовые места",
    FIN_OPERATION_TYPE: "Тип финансовой операции",
    FIN_OPERATION_ORDER_DOC_LINK: "Документы фин операций",
    GTD_ADDITIONAL_CHECK: "Дополнительные проверки и КТС",
    GTD_ADDITIONAL_CHECK_STATUS: "Статусы решений по доп.проверке",
    GTD_RESULT_RETURNING_OTP_STATUS: "Статусы результатов проверок из ОТП",
    GTD_ADDITIONAL_CHECK_TYPE: "Вид проверки",
    GTD_FACT_TYPE: "Тип декларации",
    GTD_MODE: "Режим таможни",
    GU_FORM_STATUS: "Статус ГУ",
    INSTRUCTION_EXECUTOR_TYPE: "Тип исполнителя инструкции",
    INVOICE: "Счета",
    INVOICE_INCOMING: "Входящие счета",
    INVOICE_INCOMING_MONEY: "Приход ДС",
    INVOICE_OUTGOING: "Исходящие счета",
    INVOICE_OUTGOING_MONEY: "Расход ДС",
    INVOICE_POSITIONS: "Позиции счета",
    INVOICE_TYPE: "Тип счета",
    LIST_ACTIVE_GTD: "Декларации (Текущие)",
    LIST_ADDRESS_COMPANY: "Адреса",
    LIST_AIRPORTS: "Аэропорты",
    LIST_ALL_GTD: "Декларации (Все)",
    LIST_ARCHIVE_GTD: "Декларации (Архив)",
    LIST_AUTO: "Автомашины",
    LIST_BANKS: "Банки",
    LIST_CITY: "Города",
    LIST_CLASSIFICATION: "Классификационный справочник",
    LIST_CLASSIFICATION_UPDATE: "Обновление классификационного справочника",
    LIST_CLASS_DANGER: "Классы опасностей",
    LIST_COMPANY: "Контрагенты",
    LIST_COMPANY_BANKS: "Банки-контрагенты",
    LIST_COMPANY_BANK_ACCOUNTS: "Банковские счета",
    LIST_COMPANY_CONTACT_PERSONS: "Контактные лица",
    LIST_COMPANY_GROUPS: "Группа компании",
    LIST_COMPANY_LIFE_CYCLE: "Жизненный цикл компании",
    LIST_COMPANY_MARKS: "Признак компании",
    LIST_CONTACT_PERSONS: "Контактные лица",
    LIST_CONTACT_PERSONS_DATA: "Контактные данные",
    LIST_CONTRACTS: "Договоры",
    LIST_COUNTRY: "Страны",
    LIST_CURS: "Курсы валют",
    LIST_CURS_INTERNAL: "Курсы валют",
    LIST_CUSTOMS_INSPECTORS: "Инспектора",
    LIST_DELIVERY_CONDITIONS: "Условия поставки",
    LIST_DOCUMENTS: "Документы",
    LIST_DRIVERS: "Водители",
    LIST_ETSNG: "Единая тарифно-статистическая номенклатура грузов",
    LIST_FEACC_GTD: "Товары декларации",
    LIST_FEACC_ARTICLE: "Артикулы декларации",
    LIST_GNG: "Гармонизированная номенклатура грузов",
    LIST_GTD: "Декларации",
    LIST_HOOK: "Полуприцепы",
    LIST_NAME_WEIGHT: "Наименование груза",
    LIST_NAVALPORTS: "Морские порты",
    LIST_ORDER_POSITIONS: "Спецификация",
    LIST_PERSON_POST: "Должность сотрудника",
    LIST_POST_CUSTOMS_GTD: "Возвраты денежных средств по доп.проверке",
    LIST_RAILWAYS: "Железные дороги",
    LIST_REGION: "Регионы",
    LIST_RUR_EQUIV: "Журнал переоценки",
    LIST_TNVED: "Товарная номенклатура внешнеэкономической деятельности",
    LIST_TYPE_ACCOUNT: "Типы счетов",
    LIST_TYPE_CONTRACTS: "Наименования договоров",
    LIST_TYPE_DOCUMENT: "Типы документов",
    LIST_TYPE_FEACC_DOCUMENTS: "Документы таможенных деклараций",
    LIST_TYPE_FLAT: "Тип помещения",
    LIST_TYPE_LINK: "Вид адреса",
    LIST_TYPE_MODEL_AUTO: "Марки автомашин",
    LIST_TYPE_MODEL_HOOK: "Модели полуприцепов",
    LIST_TYPE_VAN: "Тип кузова",
    LIST_USER: "Учетные записи",
    LIST_VAT: "НДС",
    LIST_WAREHOUSE: "Точки маршрута",
    LIST_WAREHOUSES_COMPANY_LINK: "Склады компаний",
    LIST_WAREHOUSES_ROLES_LINK: "Роли точек маршрута",
    LIST_WAREHOUSE_WAREHOUSES_LINK: "Точки маршрута",
    LOGISTAS_UNIT: "Грузы",
    MATERIAL: "Материал",
    OPERATION: "Операция",
    OPERATION_AIR: "Авиаперевозки",
    OPERATION_ARRIVAL_POINT: "Маршрут",
    OPERATION_AUTO: "Автоперевозки",
    OPERATION_CARGO_STATUS_EX_T1: "Статус груза ЕХ/Т1",
    OPERATION_CUSTOMS: "Таможенное оформление",
    OPERATION_DETAIL: "Детализация операции",
    OPERATION_FORWARD: "Экспедирование",
    OPERATION_FORWARD_INSPECTION: "Досмотры/Осмотры",
    OPERATION_FORWARD_INSPECTION_TYPE: "Вид операции",
    OPERATION_PACKING_UNIT_TYPE: "Единицы измерения",
    OPERATION_RATE_EXPENSE_INCLUDE: "Детализация номенклатуры",
    OPERATION_RATE_EXPENSE_TYPE: "Номенклатура",
    OPERATION_SEA: "Морские перевозки",
    OPERATION_SUB_DOC: "Документ",
    OPERATION_TRAIN: "Железнодорожные перевозки",
    OPERATION_TYPE: "Типы операций",
    OPERATION_UNIT: "Грузовая единица",
    OPERATION_UNIT_DIVISION: "Тип груза",
    OPERATION_UNIT_SCOPE: "Грузовая единица",
    OPERATION_UNIT_TYPE: "Тип грузовой единицы",
    ORDER: "Заказы",
    ORDER_DOCS_SCHEME: "Шаблон документальной схемы",
    ORDER_FOR_OWNER_UNIT: "Заказы",
    FIN_OPERATION_BY_OWNER_UNIT: "Фин операции для экспортных перевозок",
    ORDER_FOR_OWN_ROLLING_STOCK_UNIT: "Заказы",
    ORDER_REQUEST: "Коммерческое предложение",
    ORDER_REQUEST_CONTRACT_TYPE: "Вид контракта",
    OWNER_UNIT: "Экспортные перевозки",
    OWN_ROLLING_STOCK_UNIT: "Собственный подвижной состав",
    PART_NUMBER: "Инвойс",
    PART_NUMBER_POSITION: "Позиция товара",
    PAYMENT_DAY_OF_THE_MONTH: "Платежные дни",
    PAYMENT_DAY_OF_THE_WEEK: "День оплаты",
    PAYMENT_ORDERS: "Платежи",
    PAYMENT_ORDERS_EXPENCE_TYPE: "Вид расхода",
    PAYMENT_ORDERS_INCOMING: "Полученные ПП/SWIFT/Наличные ДС",
    PAYMENT_ORDERS_OUTGOING: "Отправленные ПП/SWIFT/Наличные ДС",
    PRODUCTION: "Продукция",
    PRODUCT_CATEGORY: "Категория товара",
    PRODUCT_TYPE: "Тип продукции",
    REMEMBER: "Напоминание",
    REMEMBER_TYPE: "Тип напоминания",
    REQUEST_CURRENCY_TRANSLATION: "Валютные переводы",
    REQUEST_CURRENCY_TRANSLATION_TYPE: "Тип заявки",
    REVALUE_TRANSFER: "Курсовая переоценка",
    SEA_RATES: "Морские котировки",
    SEX: "Пол",
    STORAGE_RATES: "Тарифы хранения",
    SYS_ACL_ROLE: "Права доступа",
    SYS_FILES: "Файлы",
    TRANSFER_DISLOCATION: "Дислокация",
    ROLIS_EVENT: "События Ролис",
    ROLIS_EDI: "EDI Ролис",
    ROLIS_SUBSCRIPTION: "Подписки Ролис",
    USER_ADDITIONAL_CREDENTIALS: "Сторонние учетные записи",
    USER_ADDITIONAL_CREDENTIALS_TYPE: "Тип учетной записи",
    USER_TASK: "Задачи",
    USER_TASK_IMPORTANCE: "Важность задачи",
    USER_TASK_STATUS: "Статус задачи",
    USER_TASK_THEME: "Шаблон задачи",
    USER_TASK_THEME_TO_BUS_OP: "Шаблон задачи",
    USER_TASK_TYPE: "Тип задачи",
    VESSEL: "Суда",
    WEIGHT_GROUP: "Группа товаров",
    WORK_INSTRUCTIONS: "Инструкции для работы",
    WORK_INSTRUCTIONS_CATEGORY: "Инструкции для работы",
    WORK_INSTRUCTIONS_DOCUMENT: "Инструкции для работы",
    WORK_INSTRUCTIONS_TYPE: "Тип документа",
    OPERATION_RATE_EXPENSE_CATEGORY: "Категории номенклатуры",
    CRM_REQUEST_STATUS: "Статус запроса",
    OPERATION_CUSTOM_STATUS: "Статус коносамента",
    OPERATION_CUSTOM_STATUS_TYPE: "Справочник \"Статус коносамента\"",
    REQUEST_GTD: "Заявления (ВДТ)",
    TEMPLATE_INVOICE_POST: "Шаблон расходов",
    TEMPLATE_INVOICE: "Шаблон Расхода ДС",
    LIST_CONTACT_PERSONS_EMAIL_BROADCAST_CONFIG: "Шаблон рассылки документов",
    ORDER_NOTIFICATIONS: "Рассылка по заказам",
    LIST_GTD_NOTIFICATIONS: "Рассылка по точкам маршрута",
    AUTO_RATES: "Авто котировки",
    SEA_PORT_EXPENSES: "Локальные затраты в порту",
    CAPITAL_TRANSFER: "Проводки",
    CAPITAL_ACCOUNT: "Счета",
    CONTRACTS_FEA_ADDITION_SPECIFICATIONS: "Спецификация",
    LIST_REUSABLE_CONTAINERS_POSITION: "Многооборотная тара (позиции)",
    LIST_REUSABLE_CONTAINERS: "Многооборотная тара",
    LIST_REUSABLE: "Перечень многооборотной тары",
    FEEDBACK_TYPE: "Feed-back",
    PERSON_TO_NOTIFY: "Сторона получения уведомления (notify)",
    CAPITAL_CONVERSION_OPERATION: "Конверсионная операция",
    DOCUMENT_STATUS: "Статусы документов",
    EDI_EVENT: "События EDI",
    TRAIN: "Поезда",
    CRITERIA_TYPE: "Критерий",
    CRITERIA_VALUE: "Значение критерия",
    PAYMENT_ORDERS_GROUP_EXPENCE_TYPE: "Группа расхода",
    PAYMENT_ORDERS_SUBGROUP_EXPENCE_TYPE: "Подгруппа расхода",
    SYSTEM_SYS_LOG: "Логи",
    USER_ROLE: "Роли",
    CHECK_CUSTOM_PAYMENTS_NOTE: "Примечание",
    DOCS_SEND_METHOD: "Способ отправки документов",
    DECLARATION_UNIT: "Грузовые единицы для досмотра",
    BATCH_FIN_OPERATION: "Пакетные фин операции",
    BATCH_FIN_OPERATION_BUY: "Пакетные фин операции покупка",
    CUSTOM_CURRENCY_CURS: "Пользовательские курсы",
    LIST_COMPANY_CATEGORY: "Категория контрагента",
    LIST_COMPANY_CATEGORY_GROUP: "Группа категорий",
    COMPANY_STORAGE_RATES: "Тарифы хранения",
    CUSTOM_MODE: "Таможенный режим",
    PRODUCT: "Job Solution",
    MOVE_TYPE: "Move type",
    BIZ_SCOPE: "BizScope",
    BL_TYPE: "BL type",
    TEMPLATE_NOTIFICATION_MAILING_DOC: "Шаблоны рассылки документов",
    TEMPLATE_NOTIFICATION_MAILING: "Шаблоны рассылки уведомлений",
    DYNAMIC_JOURNALS: "Клиентские журналы",
    AGREED_STATUS_NAME: "Статус согласования",
    REPORT_SETTINGS: "Настройки бланков",
    AGREED_STATUS: "Статус согласования",
    ICB_OFFICE: "ICB Offices",
    PAYABLE_CSO: "Payable CSO",
    MANAGER_BONUS: "Премии менеджерам",
    FIN_OPERATION_BY_OWN_ROLLING_STOCK_UNIT: "Фин операции для собственного подвижного состава",
    REASON_BEING_LATE: "Причина опоздания",
    ALTA_CBX_DATA: "СВХ",
    CAPITAL_TRANSFER_TEMPLATE: "Шаблон проводки",
    FinancialResultReport: "Детализация финансового результата",
    COMPANY_ADDITIONAL_INFORMATION: "Дополнительная информация",
    LIST_WAREHOUSE_TYPE_ROLE: "Роли",
    RISK_CLASS: "Класс риска",
    INDUSTRY: "Индустрия",
    LIST_OWNERSHIP_TYPE: "Типы владения",
    TEMPLATE_PAYMENT_SCHEDULE: "Шаблон графика платежей",
    SERVICE_COMBINATION: "Комбинация услуг",
    PAYMENT_SCHEDULE: "График платежей",
    GHQ_ACTIVITY: "GHQ Activity",
    CONSOL_TYPE: "Consol type",
    BRANCH_YUNAS: "Branch Yunas",
    SAMPLE_COLLECTION: "Отбор проб",
    REJECTED_BY: "Rejected by",
    WHT: "WHT"
};
